import React, { useMemo, useState } from 'react';
import { Popup, SearchBar, Selector, Toast } from 'antd-mobile';
import axios from 'axios';
import API_ROUTES from '../../api';
import { getReadyTeamName } from '../../features/match/model/readyTeamName';

const GAME_TYPE_OPTIONS = [
    { label: '上场队员', value: 0 },
    { label: '主裁', value: 1 },
    { label: '边裁', value: 2 },
    { label: 'VAR', value: 3 },
    { label: '观众', value: 4 },
];

// 临时报名单独使用单层底部面板，保持原有人员、身份、队伍和提交参数不变。
const TempSignupPopup = ({ gameDetail, memberListInfo, getUserListInfo }) => {
    const [visible, setVisible] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [memberId, setMemberId] = useState(null);
    const [gameType, setGameType] = useState(null);
    const [gameTeam, setGameTeam] = useState(1);
    const [submitting, setSubmitting] = useState(false);

    const availableMembers = useMemo(() => {
        const keyword = searchText.trim().toLowerCase();
        return (memberListInfo || []).filter(item => {
            const canSignup = ![0, 1, 2, 3, 4].includes(item.gameType) && item.tempMember === null;
            return canSignup && (!keyword || String(item.name || '').toLowerCase().includes(keyword));
        });
    }, [memberListInfo, searchText]);

    const closePopup = () => {
        setVisible(false);
        setSearchText('');
        setMemberId(null);
        setGameType(null);
        setGameTeam(1);
    };

    const submitSignup = async () => {
        if (!memberId) {
            Toast.show({ content: '请选择临时到场人员', icon: 'fail' });
            return;
        }
        if (gameType === null) {
            Toast.show({ content: '请选择上场类型', icon: 'fail' });
            return;
        }

        setSubmitting(true);
        try {
            const dataPost = {
                gameId: gameDetail.id,
                memberId,
                gameType,
                ...(gameType === 0 ? { gameTeam } : {}),
            };
            const response = await axios.post(API_ROUTES.game_tempAddMember, dataPost, {});
            if (response.data.code === 200) {
                Toast.show({ content: '添加成功！', icon: 'success' });
                closePopup();
                getUserListInfo();
            } else {
                Toast.show({ content: response.data.msg, icon: 'fail' });
            }
        } catch (error) {
            Toast.show({ content: '添加失败,请联系管理员!', icon: 'fail' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <button type="button" className="premium-btn-base premium-btn-admin ready-function-card" onClick={() => setVisible(true)}>
                <span className="premium-btn-icon">⚡</span>
                <span className="ready-function-label">临时报名</span>
                <span className="ready-function-arrow">›</span>
            </button>

            <Popup
                visible={visible}
                onMaskClick={closePopup}
                bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, maxHeight: '88vh', overflow: 'hidden' }}
                style={{ '--z-index': 1200 }}
            >
                <div className="temp-signup-sheet">
                    <div className="temp-signup-header">
                        <button type="button" onClick={closePopup}>取消</button>
                        <div>
                            <div className="temp-signup-title">临时报名</div>
                            <div className="temp-signup-subtitle">一次完成选人、身份和队伍设置</div>
                        </div>
                        <button type="button" className="primary" disabled={submitting} onClick={submitSignup}>确认</button>
                    </div>

                    <div className="temp-signup-content">
                        <div className="temp-signup-section">
                            <div className="temp-signup-label">选择人员</div>
                            <SearchBar placeholder="搜索姓名" value={searchText} onChange={setSearchText} />
                            <div className="temp-signup-member-grid">
                                {availableMembers.map(item => (
                                    <button
                                        key={item.id}
                                        type="button"
                                        className={memberId === item.id ? 'active' : ''}
                                        onClick={() => setMemberId(item.id)}
                                    >
                                        {item.name}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="temp-signup-section">
                            <div className="temp-signup-label">上场类型</div>
                            <Selector columns={3} options={GAME_TYPE_OPTIONS} value={gameType === null ? [] : [gameType]} onChange={value => setGameType(value[0] ?? null)} />
                        </div>

                        {gameType === 0 && (
                            <div className="temp-signup-section">
                                <div className="temp-signup-label">分配队伍</div>
                                <Selector
                                    columns={2}
                                    value={[gameTeam]}
                                    options={[
                                        { label: getReadyTeamName(gameDetail, 1), value: 1 },
                                        { label: getReadyTeamName(gameDetail, 2), value: 2 },
                                    ]}
                                    onChange={value => setGameTeam(value[0] || 1)}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default TempSignupPopup;
